import { useContext } from 'react'
import { useNavigate } from 'react-router-dom';
import { PrivilegeContext } from '@/context/PrivilegesContext';
import { useEffect } from 'react';
import { GetAuthorizedPages } from '@/api/endpoints';
import { DomainContext } from '@/context/DomainContext';
import { useTranslation } from 'react-i18next';

const CombinedRoutes = ({ children }) => {
  const { isLoggedIn, setAuthorizedPages } = useContext(PrivilegeContext);
  const { i18n } = useTranslation()
  const navigate = useNavigate();
  const { setLoading } = useContext(DomainContext)

  useEffect(() => {
    console.log(window.location)
    if (!isLoggedIn && !window.location.href.includes("/guest")) {
      navigate("/auth/log-in");
      setAuthorizedPages([]);
    }

    if (isLoggedIn) {

      if (window.location.pathname.includes("/auth")) return navigate("/panel");

      if (window.location.pathname.includes === "/") navigate("/panel");

      setLoading(l => l + 1)
      GetAuthorizedPages().then(res => {
        setLoading(l => l - 1)
        setAuthorizedPages(res.data)
      }).catch(() => {
        setLoading(l => l - 1)
      })
    }

  }, [isLoggedIn, window.location]);

  return (
    <div className={`${i18n.language}`}>{children}</div>
  )
}

export default CombinedRoutes